const isLocal = document.location.hostname === 'localhost';
// const isDev = document.location.hostname === 'tools-hr.xfin.net' || isLocal;


export const FEATURE_HIDE_SANDBOX = isLocal;
